import axios from "axios";

export const generarGuia = ({bodega, valorTotal, pedido}) => {


    const validarDato = (dato, max) => {

        if (!dato) {
            return 'N/A'
        }

        if (dato.length < max) {
            return dato
        }

        return dato.substr(0, max)


    }

    const validarTelefono = (cel) => {

        let num = cel.replaceAll(' ', '')
        num = num.replaceAll('-', '')
        return num

    }

    let data = JSON.stringify(
        {
            "idRate": pedido.idRate,
            "myShipmentReference": `Pedido #${pedido.consecutivo}`,
            "external_order_id": pedido.consecutivo,
            "requestPickup": false,
            "pickupDate": "2027-11-24",
            "insurance": true,
            "description": `Prendas Amevi`,
            "contentValue": valorTotal,
            "codValue": valorTotal,
            "includeGuideCost": false,
            "codPaymentMethod": "cash",
            "packages": [
                {
                    "weight": pedido.pesoTotal,
                    "height": pedido.alto,
                    "width": pedido.ancho,
                    "length": pedido.fondo
                }
            ],
            "origin": {
                "company": 'Amevi',
                "firstName": bodega.nombre,
                "lastName": bodega.apellido,
                "email": bodega.correo,
                "phone": bodega.celular,
                "address": bodega.direccion,
                "suburb": bodega.adicional,
                "crossStreet": bodega.calle,
                "reference": bodega.referencia,
                "daneCode": bodega.codigo
            },
            "destination": {
                "company": "N/A",
                "firstName": validarDato(pedido.nombres, 14),
                "lastName": validarDato(pedido.apellidos, 14),
                "email": validarDato(pedido.correo, 60),
                "phone": validarDato(validarTelefono(pedido.celular), 10),
                "address": validarDato(pedido.direccion, 50),
                "suburb": validarDato(pedido.barrio, 30),
                "crossStreet": 'N/A',
                "reference": validarDato(pedido.indicaciones, 25),
                "daneCode": JSON.stringify(pedido.codigoDane)
            }
        }
    );


    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //  url: 'https://api.envioclickpro.com.co/api/v2/shipment_sandbox', //test
        url: 'https://api.envioclickpro.com.co/api/v2/shipment',
        headers: {
            'Authorization': 'd579cb35-81f8-4590-8d71-19cb90221223',
            'Content-Type': 'application/json',
        },
        data: data
    };


    return new Promise((resolve) => {
        // console.log(data)

        axios(config)
            .then(function (response) {
                console.log(response)
                if (response.status === 200) {
                    return resolve({res: true, data: response.data.data})
                } else {
                    return resolve({res: false, data: "error interno"})
                }
            })
            .catch(function (error) {
                console.log(error)
                return resolve({res: false, data: error.response.data.error, dataError: error.response})
            });

    })

}